<h2>Адрес доставки</h2>
<div class="address">
  <ng-container [ngSwitch]="state$ | async">
    <ng-container *ngSwitchCase="state.Loading">
      <div class="skelet"></div>
    </ng-container>
    <ng-container *ngSwitchCase="state.AddAddress">
      <sd-delivery-add-address text="Добавить адрес"></sd-delivery-add-address>
    </ng-container>
    <ng-container *ngSwitchCase="state.ShowAddress">
      <sd-delivery-active-address></sd-delivery-active-address>
    </ng-container>
    <ng-container *ngSwitchCase="state.ShowMobileAddress">
      <sd-delivery-active-address></sd-delivery-active-address>
      <button
        sdButton
        type="secondary"
        fullWidth="true"
        (click)="openDeliveryAddressListModal()"
        data-testid="changeDelivery"
        ngbTooltip="Изменить адрес"
        triggers="manual"
      >
        <cx-icon class="icon" [type]="iconType.POINT"></cx-icon>
        Изменить адрес
      </button>
    </ng-container>
  </ng-container>
</div>
